export default "__VITE_ASSET__C2irzuM7__"